export default __webpack_public_path__ + "static/AlgaeBlooms-bf76cf2e28a657649d7de8b712f79ea9.png";